import { Workspace } from 'contexts';
import { PrivilegeSet } from 'kineticUtils';
import { Layout } from 'react-grid-layout';
import { PREFERENCE_KEYS } from 'types';

export type GridItemData = any;

export interface GridLayout {
  [key: string]: GridLayoutItem;
}
export interface GridLayoutItem {
  gridItemProps: GridItemProps;
  layout: Layout;
}

export enum GridItemType {
  /**
   * A grid item that holds an iframe.
   */
  IFRAME = 'IFRAME',
  JSX = 'JSX',
  KINETIC_ROUTE = 'KINETIC_ROUTE',
}
export interface GridItemState {
  title: string;
  subtitle?: string;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export interface GridItemConfig<TData = any> extends GridItemState {
  type: GridItemType;
  data: TData;
  id: string;
}

export interface SetTitleAction {
  type: 'setTitle';
  payload: string;
}

export interface SetSubtitleAction {
  type: 'setSubtitle';
  payload: string;
}

export type GridItemAction = SetTitleAction | SetSubtitleAction;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export interface GridItemProps<TData = any> extends GridItemConfig<TData> {
  onGridItemClose: () => void;
  supportsFrame?: boolean;
  routes: JSX.Element[];
  to?: string;
  privilegeSet?: PrivilegeSet;
}

export interface GridItemComponentProps extends GridItemProps {
  workspaceId: string;
  preferenceKey: PREFERENCE_KEYS | (string & {});
  activeWorkspace?: Workspace;
  commonGridItemData?: Workspace['gridItemData'];
}

export interface WidgetRouteInfo {
  name: string;
  to: string;
}
